<div class="w-full">
     @if(isPartner){
        @if(brantTermNotAccepted == 'false'){
           
            <div class=" bg-red-100 font-medium  p-4 m-8 !mb-0 rounded shadow-sm shadow-[red] flex items-center gap-3">
                <div class="flex gap-3 items-center">
                 <mat-icon class="!h-15 !w-15 !fill-black bell-icon"
                [svgIcon]="'heroicons_outline:bell-alert'"
            ></mat-icon>
                <span>
                To start selling on Grimmor, you must review and accept the Seller Terms.
                    Until the Seller Terms are accepted, your shop will remain offline and your products will not be visible to users.</span>
                    </div>
            <button mat-flat-button class="btn-theme-color !min-w-[90px] p-2 rounded"  (click)="openPopup()"
                type="button">
               Review
            </button>
            
        </div>
            }
            @if(!stripeConfigured){<div class=" bg-red-100 font-medium  p-4 m-8 !mb-0 rounded shadow-sm shadow-[red] flex items-center gap-3">
                <div class="flex gap-3 items-center">
                 <mat-icon class="!h-15 !w-15 !fill-black bell-icon"
                [svgIcon]="'heroicons_outline:bell-alert'"
            ></mat-icon>
                <span>
                    To start getting payments on Grimmor, you must configure Stripe Account. Until the Stripe account is not configured, you will not receive any payments from the users. 
                </span>
                    </div>
            <button mat-flat-button class="btn-theme-color !min-w-[90px] p-2 rounded"  (click)="configureStripeAccount()"
                type="button">
               Configure
            </button>
            
        </div>}
        @if(isShow){
    <div class="flex justify-end items-center px-7 pt-7">
        @if(!isConnected){
        @if(storeType == 'shopify'){<button  class="btn-theme-color flex gap-1 font-semibold items-center px-4 py-3 rounded-full !bg-[#000000]" (click)="connectToShopify(partnerUrl, partnerId)">
            <img class="w-6 h-6" src="icons/shopify-fill.svg" alt="">
            <span class="mt-[2px]">
                {{ LABELS.CONNECT_TO_SHOPIFY_STORE}}
            </span>
        </button>}
         @if(storeType == 'wooCommerce'){<button  class="btn-theme-color flex gap-1 font-semibold items-center px-4 py-3 rounded-full !bg-[#000000]" (click)="connectToWoo()">
            <img class="w-6 h-6" src="icons/woo-logo.svg" alt="">
            <span class="mt-[2px]">
                {{ LABELS.CONNECT_TO_WOO_STORE}}
            </span>
        </button>}
        } @else {
            @if(storeType == 'shopify'){<button  class="btn-theme-color flex gap-1 font-semibold items-center px-4 py-3 rounded-full !bg-[#64943e]">
            <img class="w-6 h-6" src="icons/shopify-fill.svg" alt="">
            <span class="mt-[2px]">
                {{ LABELS.CONNTED_WITH_YOUR_SHOPIFY_STORE}}
            </span>
        </button>}
        @if(storeType == 'wooCommerce'){<button  class="btn-theme-color flex gap-1 font-semibold items-center px-4 py-3 rounded-full !bg-[#64943e]">
            <img class="w-6 h-6" src="icons/woo-logo.svg" alt="">
            <span class="mt-[2px]">
                {{ LABELS.CONNTED_WITH_YOUR_WOO_STORE}}
            </span>
        </button>}
        }
    </div>
    }
}
    <div class="custom-row">
        @for (data of dashboardDataList; track data) {
        <div class="custom-col">
            <div class="card" [ngClass]="'cursor-pointer'" (click)="redirectToPage(data?.name)">
                <div class="info-box">
                    <div class="box-top">
                        <h4>Total number of <br>{{ data?.name ? (data?.name == 'Marketplace Items' ? 'Vintage Items' : data?.name) : '-' }}</h4>
                        <span>{{ data?.totalCount ? data.totalCount : 0}}</span>
                    </div>
                    <div class="image-box">
                        <!--<img alt="icon" height="40" src="" width="40">-->
                        <mat-icon class="theme-color icon" [svgIcon]="data?.icon ? data.icon : url"></mat-icon>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>


</div>